import { useState } from "react";
import { groups } from "@/mocks/homeData";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GroupsSection() {
  const [joined, setJoined] = useState<string[]>([]);

  const toggleJoin = (id: string) => {
    setJoined((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <section id="groups" className="w-full border-t border-background-200 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Groups · 群组广场"
          title="群组共建，同一类爆料集中聊"
          desc="群组是按讨论主题聚合的小圈子，成员把碎片线索拼成完整脉络，新人进入即可顺着时间线回看。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {groups.map((group) => {
            const isJoined = joined.includes(group.id);
            return (
              <div
                key={group.id}
                className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="h-14 w-14 shrink-0 overflow-hidden rounded-lg border border-background-200 bg-background-100">
                  <img
                    src={group.avatar}
                    alt={`${group.name} 群组 黑料社区`}
                    title={`${group.name} 群组 黑料社区`}
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="truncate font-heading text-base font-bold text-foreground-950">
                      {group.name}
                    </h4>
                  </div>
                  <div className="mt-1.5 flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-800">
                      {group.badge}
                    </span>
                    <span className="whitespace-nowrap text-xs text-foreground-500">{group.category}</span>
                  </div>
                  <p className="mt-1.5 text-xs text-foreground-500">
                    {group.members} 成员 · 今日 {group.todayPosts} 帖
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => toggleJoin(group.id)}
                  className={`flex h-9 shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-3 text-xs font-medium transition-colors ${
                    isJoined
                      ? "bg-primary-100 text-primary-700"
                      : "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                  }`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={isJoined ? "ri-check-line" : "ri-add-line"}></i>
                  </span>
                  {isJoined ? "已加入" : "加入"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}